export const incidentsTour = {
    module: 'incidents',
    title: 'Incidents Tour',
    title_vi: 'Tour Sự cố',
    description: 'As the Incident Commander (P-VN-09), detect and report data breaches with 72-hour PDPL notification obligations to the PDP Committee, triage by severity, and build audit-grade incident dossiers.',
    description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: As the Incident Commander (P-VN-09), detect and report data breaches with 72-hour PDPL notification obligations to the PDP Committee, triage by severity, and build audit-grade incident dossiers.',
    estimated_duration_seconds: 70,
    steps: [
        {
            step_id: 'open_incidents',
            navigate_to: '/admin/incidents',
            target: '.dm-page',
            wait_for: '.dm-page',
            title: 'Incident Detection & Reporting',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Incident Detection & Reporting',
            description: 'As the Incident Commander, you report and triage breaches here. Unlike Incident Ops (which handles playbook execution and SLA tracking), this module focuses on detection, initial reporting, and the 72-hour PDPL notification obligation.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: As the Incident Commander, you report and triage breaches here. Unlike Incident Ops (which handles playbook execution and SLA tracking), this module focuses on detection, initial reporting, and the 72-hour PDPL notification obligation.',
            position: 'bottom',
        },
        {
            step_id: 'incidents_list',
            target: '.dm-table',
            title: 'Incident List',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Incident List',
            description: 'All reported incidents with severity, PDPL notification status, and SLA countdown. Critical data breaches are highlighted as they trigger the 72-hour PDP Committee notification requirement.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: All reported incidents with severity, PDPL notification status, and SLA countdown. Critical data breaches are highlighted as they trigger the 72-hour PDP Committee notification requirement.',
            position: 'bottom',
        },
        {
            step_id: 'report_incident',
            target: '.dm-header .btn-primary',
            title: 'Report an Incident',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Report an Incident',
            description: 'Report a new breach or incident. The 72-hour PDPL notification clock starts from the moment the breach is confirmed.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Report a new breach or incident. The 72-hour PDPL notification clock starts from the moment the breach is confirmed.',
            position: 'bottom',
            action: { type: 'click', target: '.dm-header .btn-primary' },
            duration_ms: 100,
        },
        {
            step_id: 'incidents_template_picker',
            target: '.dm-modal .template-picker',
            wait_for: '.template-picker',
            title: 'Choose an Incident Template',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Choose an Incident Template',
            description: 'Select a pre-built incident template for common breach scenarios (data breach, ransomware, insider threat), or start from a blank report.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Select a pre-built incident template for common breach scenarios (data breach, ransomware, insider threat), or start from a blank report.',
            position: 'bottom',
            delay_ms: 500,
        },
        {
            step_id: 'incidents_select_template',
            target: '.template-picker-blank',
            title: 'Start from Blank',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Start from Blank',
            description: 'Select the blank template to report the incident from scratch with full control over classification and details.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Select the blank template to report the incident from scratch with full control over classification and details.',
            position: 'bottom',
            action: { type: 'click', target: '.template-picker-blank' },
            delay_ms: 300,
        },
        {
            step_id: 'fill_incident_title',
            target: '[data-testid="incident-title"]',
            wait_for: '.dm-form-modal',
            title: 'Describe the Incident',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Describe the Incident',
            description: 'Provide a concise title covering what happened and affected systems. This title appears in PDP Committee notifications and internal escalation alerts.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Provide a concise title covering what happened and affected systems. This title appears in PDP Committee notifications and internal escalation alerts.',
            position: 'bottom',
            action: {
                type: 'fill',
                target: '[data-testid="incident-title"]',
                value: '[TOUR] Unauthorized Access to Customer Database',
            },
        },
        {
            step_id: 'fill_severity',
            target: '[data-testid="incident-severity"]',
            title: 'Set Severity Level',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Set Severity Level',
            description: 'Classify severity to determine SLA timelines and escalation paths. Critical and high-severity breaches involving personal data trigger PDPL mandatory notification to the PDP Committee.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Classify severity to determine SLA timelines and escalation paths. Critical and high-severity breaches involving personal data trigger PDPL mandatory notification to the PDP Committee.',
            position: 'bottom',
            action: { type: 'select', target: '[data-testid="incident-severity"]', value: 'high' },
        },
        {
            step_id: 'submit_incident',
            target: '.dm-modal-footer .dm-btn-primary',
            title: 'Submit the Incident',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Submit the Incident',
            description: 'Submit to register the incident and start SLA tracking. The incident becomes visible in the Incident Ops module for playbook activation and response coordination.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Submit to register the incident and start SLA tracking. The incident becomes visible in the Incident Ops module for playbook activation and response coordination.',
            position: 'top',
        },
        {
            step_id: 'incident_reports',
            navigate_to: '/admin/incidents/reports',
            target: '.dm-page',
            wait_for: '.dm-page',
            title: 'Incident Reports',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Incident Reports',
            description: 'Aggregate incident metrics for DPO reporting and board presentations. Shows breach trends, resolution rates, and PDPL notification compliance statistics.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Aggregate incident metrics for DPO reporting and board presentations. Shows breach trends, resolution rates, and PDPL notification compliance statistics.',
            position: 'bottom',
        },
        {
            step_id: 'incident_tasks',
            navigate_to: '/admin/incidents/tasks',
            target: '.dm-page',
            wait_for: '.dm-page',
            title: 'Incident Tasks',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Incident Tasks',
            description: 'Manage response tasks across all incidents. These tasks drive containment, notification, and remediation activities required by PDPL breach response obligations.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Manage response tasks across all incidents. These tasks drive containment, notification, and remediation activities required by PDPL breach response obligations.',
            position: 'bottom',
        },
        {
            step_id: 'incident_task_templates',
            target: '.dm-header button:first-child',
            title: 'Task Templates',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Task Templates',
            description: 'Browse reusable templates for common breach response activities: containment, forensic analysis, data subject notification, and PDP Committee reporting.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Browse reusable templates for common breach response activities: containment, forensic analysis, data subject notification, and PDP Committee reporting.',
            position: 'bottom',
            action: { type: 'click', target: '.dm-header button:first-child' },
            duration_ms: 300,
        },
        {
            step_id: 'incident_task_templates_modal',
            target: '.dm-modal',
            wait_for: '.dm-modal',
            title: 'Task Template Library',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Task Template Library',
            description: 'Select a template to pre-fill task details. Templates ensure consistent, auditable breach response procedures aligned with PDPL requirements.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Select a template to pre-fill task details. Templates ensure consistent, auditable breach response procedures aligned with PDPL requirements.',
            position: 'right',
            action: { type: 'click', target: '.dm-form-actions button' },
            duration_ms: 300,
        },
        {
            step_id: 'incident_new_task',
            target: '.dm-header button:last-child',
            title: 'Create a Task',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Create a Task',
            description: 'Assign response tasks to team members with deadlines and priority. Each completed task builds the audit-grade evidence trail proving your PDPL breach response diligence.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Assign response tasks to team members with deadlines and priority. Each completed task builds the audit-grade evidence trail proving your PDPL breach response diligence.',
            position: 'bottom',
        },
        {
            step_id: 'incident_complete',
            target: '.dm-page',
            title: 'Incidents Tour Complete',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Incidents Tour Complete',
            description: 'You can now report breaches, classify severity for PDPL notification obligations, assign response tasks, and produce audit-grade incident dossiers. Use Incident Ops for playbook execution and SLA management.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: You can now report breaches, classify severity for PDPL notification obligations, assign response tasks, and produce audit-grade incident dossiers. Use Incident Ops for playbook execution and SLA management.',
            position: 'bottom',
        },
    ],
};
//# sourceMappingURL=incidents.js.map